/*  Copyright (C) 2020 OhmConnect, Inc. - All Rights Reserved  */
export {default} from './Icon';
